<template>
	<v-col class="background">
		<v-row>
			<v-col class="d-flex">
				<v-img
					:src="require('assets/static/img/logo/hotpicklotto_yellow.png')"
					alt="logo"
					contain
					width="100"
					height="100"
				/>
			</v-col>
			<v-col class="d-flex">
				<v-img
					:src="require('assets/static/img/logo/hotpicklotto_black.png')"
					alt="logo"
					contain
					width="100"
					height="100"
				/>
			</v-col>
			<v-col class="d-flex">
				<v-img
					:src="require('assets/static/img/logo/hotpicklotto_red.png')"
					alt="logo"
					contain
					width="100"
					height="100"
				/>
			</v-col>
		</v-row>
		<v-row
			v-for="number in result.numbers"
			:key="number.playType.id"
			no-gutters
		>
			<v-col class="text-center" cols="4" align-self="center">
				<img
					:src="imageForPlayType(number.playType)"
					width="200"
					alt="playType"
					class="pick"
				/>
			</v-col>
			<v-col cols="8">
				<img
					v-for="(result, index) in number.digits"
					:key="index"
					:src="balls[parseInt(result, 10)]"
					height="120"
					alt="result"
					class="ball"
				/>
			</v-col>
		</v-row>
	</v-col>
</template>

<script>
import ResultField from '../../../../enumerations/ResultField.json';
import ball0 from 'assets/static/img/balls/hotpicklotto/ball_0_black.png';
import ball1 from 'assets/static/img/balls/hotpicklotto/ball_1_black.png';
import ball2 from 'assets/static/img/balls/hotpicklotto/ball_2_black.png';
import ball3 from 'assets/static/img/balls/hotpicklotto/ball_3_black.png';
import ball4 from 'assets/static/img/balls/hotpicklotto/ball_4_black.png';
import ball5 from 'assets/static/img/balls/hotpicklotto/ball_5_black.png';
import ball6 from 'assets/static/img/balls/hotpicklotto/ball_6_black.png';
import ball7 from 'assets/static/img/balls/hotpicklotto/ball_7_black.png';
import ball8 from 'assets/static/img/balls/hotpicklotto/ball_8_black.png';
import ball9 from 'assets/static/img/balls/hotpicklotto/ball_9_black.png';

import pick2 from 'assets/static/img/picks/hotpicklotto/pick2.png';
import pick3 from 'assets/static/img/picks/hotpicklotto/pick3.png';
import pick4 from 'assets/static/img/picks/hotpicklotto/pick4.png';
import pick5 from 'assets/static/img/picks/hotpicklotto/pick5.png';

export default {
	name: 'WinningNumbers',
	props: {
		result: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			balls: [
				ball0,
				ball1,
				ball2,
				ball3,
				ball4,
				ball5,
				ball6,
				ball7,
				ball8,
				ball9
			]
		};
	},
	mounted() {
		this.$confetti.start();
	},
	destroyed() {
		this.$confetti.stop();
	},
	methods: {
		imageForPlayType(playType) {
			switch (playType.id) {
				case ResultField.PickTwo:
					return pick2;
				case ResultField.CashThree:
					return pick3;
				case ResultField.PickFour:
					return pick4;
				case ResultField.PickFive:
					return pick5;
			}
		}
	}
};
</script>
